/* article-floating-cta.js — mostra o cartão depois de 25% de rolagem, esconde
   enquanto o CTA final está na tela e perto do rodapé, e lembra o X pela
   sessão. Sem dependência externa, sem biblioteca, ~50 linhas.

   Por que a checagem de "perto do rodapé": no template de post o rodapé vem
   depois do CTA final, então sem ela a barra do mobile voltaria por cima do
   fim do rodapé. É o mesmo problema que o `opr-sticky-cta` resolve com
   `body{padding-bottom}` na home; aqui não precisa de padding permanente. */
(function () {
  var KEY = 'asee-fcta-dismissed';

  function init() {
    var el = document.querySelector('.asee-fcta');
    if (!el) return;

    try {
      if (window.sessionStorage && sessionStorage.getItem(KEY) === '1') {
        el.parentNode.removeChild(el);
        return;
      }
    } catch (e) {
      /* sessionStorage bloqueado: segue sem memória */
    }

    var threshold = parseFloat(el.getAttribute('data-threshold')) || 0.25;
    var blockers = document.querySelectorAll(el.getAttribute('data-watch') || '');
    var blocked = false;
    var ticking = false;

    /* Conta quantos alvos estão na tela, um por um. NÃO dá para decidir só
       pelas `entries` de uma chamada: o observer só entrega os que MUDARAM.
       Quando a faixa de quadros saía da tela enquanto o CTA final já estava
       nela, a chamada trazia só a faixa (isIntersecting=false) e a versão
       antiga concluía "nada na tela" e acendia o cartão em cima do CTA.
       Visto no live em /blogs/legal/can-i-legally-copy-a-painting, 11/09/2026. */
    if (window.IntersectionObserver && blockers.length) {
      var active = 0;
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var target = entries[i].target;
          var was = target.getAttribute('data-asee-in') === '1';
          var now = entries[i].isIntersecting;
          if (was !== now) {
            target.setAttribute('data-asee-in', now ? '1' : '0');
            active += now ? 1 : -1;
          }
        }
        if (active < 0) active = 0;
        blocked = active > 0;
        update();
      }, { threshold: 0 });
      for (var i = 0; i < blockers.length; i++) io.observe(blockers[i]);
    }

    function update() {
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      if (max < 400) {
        el.classList.remove('is-on');
        return;
      }
      var y = window.pageYOffset || doc.scrollTop;
      var nearBottom = y > max - 120;
      el.classList.toggle('is-on', !blocked && !nearBottom && y / max > threshold);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        update();
      });
    }

    var close = el.querySelector('.asee-fcta__close');
    if (close) {
      close.addEventListener('click', function () {
        el.classList.remove('is-on');
        try {
          if (window.sessionStorage) sessionStorage.setItem(KEY, '1');
        } catch (e) {
          /* ignora */
        }
        window.setTimeout(function () {
          if (el.parentNode) el.parentNode.removeChild(el);
        }, 300);
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
